import React from 'react';
import { formatCurrency, formatNumber } from '../../utils/formatters';

export default function StatCard({ label, value, sub, type = 'number', accent = false, trend, trendLabel }) {
  const display = type === 'currency' ? formatCurrency(value) : type === 'raw' ? value : formatNumber(value);
  const trendClass = trend > 0 ? 'trend-up' : trend < 0 ? 'trend-down' : '';

  return (
    <div className={`stat-card ${accent ? 'stat-card-accent' : ''}`}>
      <div className="label">{label}</div>
      <div className="value mono-number">{display}</div>
      {sub && <div className="sub">{sub}</div>}
      {trend !== undefined && (
        <div className={`trend ${trendClass}`} style={{ marginTop: '0.375rem' }}>
          {trend > 0 ? '▲' : '▼'} {Math.abs(trend)}% {trendLabel}
        </div>
      )}
    </div>
  );
}